import { PlusIcon } from '@buffer-mono/popcorn'

import { DEFAULT_AVATAR } from '../../../Common/utils'

import styles from './Post.module.css'

import type { JSX } from 'react'

type Props = {
  avatar: string
}

export const TikTokAvatar = ({ avatar }: Props): JSX.Element => {
  return (
    <div className={styles.avatarWrapper}>
      <div
        className={styles.avatar}
        data-testid="avatar"
        style={{ backgroundImage: `url(${avatar}), url(${DEFAULT_AVATAR})` }}
      />
      <div className={styles.avatarAddWrapper}>
        <PlusIcon size={10} className={styles.avatarAddIcon} />
      </div>
    </div>
  )
}
